<template>
    <div ref="container">
        <div class="box">
            <div class="y-list">
                <dl v-for="(item, index) in couponsList">
                    <dt>
                        <b>{{item.title}}</b>
                        <p>有效期：{{item.day}} 天</p>
                    </dt>
                    <dd>
                        <sub>￥</sub>{{item.money}}
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>
<script>
    import { levelInfo } from "@api/user";
    const NAME = 'couponFd'
    export default {
        name: "couponFd",
        components: {},
        props: {},
        data: function() {
            return {
                cid: 0,
                couponsList: [],
                loading: false
            };
        },
        mounted: function() {
            this.cid = this.$route.query.id || 0
            this.getUseCoupons();
        },
        methods: {
            getUseCoupons: function() {
                let that = this;
                levelInfo(this.cid).then(res => {
                    that.couponsList = res.data.fd;
                    that.loading = true;
                });
            }
        }
    };
</script>

<style type="text/css">
    .box{
        background: url("../../../assets/images/t-bg.jpg") center top no-repeat #e95237;
        background-size: 100% auto;
        min-height: 100vh;
    }
    .y-list{
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        padding-top: 330px;
    }
    .y-list dl{
        display: flex;
        height: 106px;
        background: linear-gradient(0deg, #FFEDE6, #FFFFFF);
        box-shadow: 0px 0px 36px 0px rgba(165,19,21,0.67);
        border-radius:10px;
        align-items: center;
        margin: 0;
        margin-bottom: 10px;
    }
    .y-list dl dt{
        display: flex;
        flex-direction: column;
        margin: 0;
        padding-left: 16px;
        flex: 1;
        padding-right: 16px;
    }
    .y-list dl dt b{
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 18px;
        color: #EE100C;
        background: linear-gradient(180deg, #FF551D 0%, #E80000 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .y-list dl dt p{
        display: flex;
        margin: 0;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #0D0D0D;
        margin-top: 10px;
    }
    .y-list dl dd{
        display: flex;
        width: 110px;
        border-left: 1px dashed #F2270D;
        height: 85px;
        align-items: center;
        justify-content: center;
    }
    .y-list dl dd{
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 35px;
        color: #EE100C;
        background: linear-gradient(180deg, #FF551D 0%, #E80000 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .y-list dl dd sub{
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 24px;
        color: #EE100C;
        margin-top: 10px;
    }
</style>
